import * as React from 'react';
import { Router } from '../router';
import App from '../App';

interface IState {
  name: string;
}

export default class Profile extends React.Component<{}, IState> {
  constructor(props: {}) {
    super(props)
    this.state = {
      name: localStorage.getItem('name') || ''
    }
  }

  render() {
    const savedName = localStorage.getItem('name')
    const { name } = this.state
    return (
      <div
        className="textContent"
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'flex-start'
        }}
      >
        {!savedName && <div style={{ textAlign: 'center' }}>Welcome to our maintenence app!<br />To start please</div>}
        <h1
          style={{
            fontWeight: 'normal',
            margin: 0,
            marginBottom: 37,
            marginTop: 37,
            padding: 0
          }}
        >
          {savedName ? 'Profile' : 'Enter Your Name'}
        </h1>
        {savedName && (
          <h3>Your Name</h3>
        )}
        <input
          type="text"
          name="name"
          id="name"
          value={name || ''}
          placeholder="Name"
          style={{
            fontSize: '120%',
            height: 37,
            marginBottom: 37,
            marginLeft: 25,
            marginRight: 25,
            maxWidth: 190,
            textAlign: 'center',
            width: '100%',
          }}
          onChange={this.updateName}
          onKeyUp={this.onKeyUp}
        />
        <button
          style={{
            fontSize: '120%',
            height: 37,
            marginLeft: 20,
            marginRight: 20,
            maxWidth: 200,
            width: '100%'
          }}
          onClick={!savedName ? this.saveAndProceed : this.save}
        >
          {savedName ? 'Update' : 'Save'}
        </button>
      </div>
    );
  }

  updateName = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ name: event.currentTarget.value });
  };

  saveAndProceed = () => {
    localStorage.setItem('name', this.state.name);
    Router.shared.navigateTo('/tasks')
  };

  save = () => {
    localStorage.setItem('name', this.state.name);
    App.default!.forceUpdate();
  }

  onKeyUp = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.keyCode === 13) {
      const savedName = localStorage.getItem('name')
      if (savedName) {
        this.save()
      } else {
        this.saveAndProceed()
      }
    }
  }

}


// WEBPACK FOOTER //
// ./src/profile/Profile.tsx